import config from '../constants/config';
import { useContractRead } from 'wagmi';
import { useEffect, useMemo, useState } from 'react';

const useFancyBearsInWallet = (
  walletAddress?: string
): [tokenIds: number[] | undefined, readFancyBearsInWallet: () => void] => {
  const [tokensInWallet, setNftsInWallet] = useState<number[]>();

  const { data, refetch } = useContractRead({
    addressOrName: config.contracts.fancyBearsContract.address,
    contractInterface: config.contracts.fancyBearsContract.interface,
    functionName: 'tokensInWallet',
    args: walletAddress,
  });

  useEffect(() => {
    if (data) {
      setNftsInWallet(data?.map(bn => bn.toNumber() as number));
    }
  }, [data]);

  return useMemo(() => [tokensInWallet, refetch], [tokensInWallet, refetch]);
};

export default useFancyBearsInWallet;
